import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const EmojiHappy: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 52 52" {...rest}>
      <g
        id="Icons/Body/Mental-Health-3"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Group" transform="translate(3.000000, 3.000000)" stroke="#222222" strokeWidth="3">
          <path
            d="M0,23 C0,35.7025492 10.2974508,46 23,46 C35.7025492,46 46,35.7025492 46,23 C46,10.2974508 35.7025492,0 23,0 C10.2974508,0 0,10.2974508 0,23 Z"
            id="Path"
          ></path>
          <path
            d="M36.8,26.0666667 C36.8,33.6881962 29.5298973,38.8212121 23,38.8212121 C16.4701027,38.8212121 9.2,33.6881962 9.2,26.0666667"
            id="Path"
          ></path>
          <path
            d="M36.2745778,15.3333333 C35.6250829,17.171784 33.8870952,18.4010393 31.9372889,18.4010393 C29.9874826,18.4010393 28.2494949,17.171784 27.6,15.3333333"
            id="Path"
          ></path>
          <path
            d="M18.4,15.3333333 C17.7505051,17.171784 16.0125174,18.4010393 14.0627111,18.4010393 C12.1129048,18.4010393 10.3749171,17.171784 9.72542222,15.3333333"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  );
};
